var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelp = function SvgHelp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12 22.5c2.9 0 5.524-1.175 7.425-3.075 1.9-1.9 3.075-4.526 3.075-7.425 0-2.9-1.175-5.524-3.075-7.425A10.467 10.467 0 0 0 12 1.5c-2.9 0-5.524 1.175-7.425 3.075A10.467 10.467 0 0 0 1.5 12c0 2.9 1.175 5.524 3.075 7.425 1.9 1.9 4.526 3.075 7.425 3.075Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.188 14v-1.625A2.437 2.437 0 1 0 9.75 9.938"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M12.188 14v-1.625A2.437 2.437 0 1 0 9.75 9.938"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2887B4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12.453 16.64a.266.266 0 1 1-.531 0 .266.266 0 0 1 .531 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICA8ZyBjbGlwLXBhdGg9InVybCgjYSkiPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMS41IiBkPSJNMTIgMjIuNWMyLjkgMCA1LjUyNC0xLjE3NSA3LjQyNS0zLjA3NSAxLjktMS45IDMuMDc1LTQuNTI2IDMuMDc1LTcuNDI1IDAtMi45LTEuMTc1LTUuNTI0LTMuMDc1LTcuNDI1QTEwLjQ2NyAxMC40NjcgMCAwIDAgMTIgMS41Yy0yLjkgMC01LjUyNCAxLjE3NS03LjQyNSAzLjA3NUExMC40NjcgMTAuNDY3IDAgMCAwIDEuNSAxMmMwIDIuOSAxLjE3NSA1LjUyNCAzLjA3NSA3LjQyNSAxLjkgMS45IDQuNTI2IDMuMDc1IDcuNDI1IDMuMDc1WiIvPgogICAgPHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEyLjE4OCAxNHYtMS42MjVBMi40MzcgMi40MzcgMCAxIDAgOS43NSA5LjkzOCIvPgogICAgPHBhdGggc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGQ9Ik0xMi4xODggMTR2LTEuNjI1QTIuNDM3IDIuNDM3IDAgMSAwIDkuNzUgOS45MzgiLz4KICAgIDxwYXRoIGZpbGw9IiMyODg3QjQiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNSIgZD0iTTEyLjQ1MyAxNi42NGEuMjY2LjI2NiAwIDEgMS0uNTMxIDAgLjI2Ni4yNjYgMCAwIDEgLjUzMSAwWiIvPgogIDwvZz4KICA8ZGVmcz4KICAgIDxjbGlwUGF0aCBpZD0iYSI+CiAgICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoMjR2MjRIMHoiLz4KICAgIDwvY2xpcFBhdGg+CiAgPC9kZWZzPgo8L3N2Zz4K";